export default __webpack_public_path__ + "static/media/jackpot-mobile-cn.9e0fe597.webp";